/**
 * Grail27 Linktree — click tracking + VIP signup modal.
 * Page views are counted automatically by Shopify for the published page URL.
 * VIP submissions arrive in Admin → Inbox / Customers (contact form, tag: VIP Collectors).
 */
(function () {
  var root = document.querySelector('[data-grail-linktree]');
  if (!root) return;

  function track(label, href) {
    var detail = {
      event: 'grail_linktree_click',
      link_label: label,
      link_url: href || '',
      page_path: window.location.pathname
    };

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(detail);
    } catch (e) {}

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'linktree_click', {
        event_category: 'linktree',
        event_label: label,
        link_url: href || ''
      });
    }

    if (
      typeof window.Shopify !== 'undefined' &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    ) {
      window.Shopify.analytics.publish('grail_linktree_click', {
        label: label,
        url: href || ''
      });
    }
  }

  root.addEventListener('click', function (event) {
    var tracked = event.target.closest('[data-glt-track]');
    if (!tracked || !root.contains(tracked)) return;
    if (tracked.matches('a, button')) {
      track(tracked.getAttribute('data-glt-track') || tracked.textContent.trim(), tracked.href || '');
    }
  });

  var modal = root.querySelector('[data-glt-vip-modal]');
  if (!modal) return;

  var dialog = modal.querySelector('[data-glt-vip-dialog]');
  var openers = root.querySelectorAll('[data-glt-vip-open]');
  var lastFocus = null;

  function openModal() {
    lastFocus = document.activeElement;
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (dialog) dialog.focus();
  }

  function closeModal() {
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  openers.forEach(function (btn) {
    btn.addEventListener('click', function () {
      openModal();
    });
  });

  modal.addEventListener('click', function (event) {
    if (event.target.closest('[data-glt-vip-close]')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hasAttribute('hidden')) {
      closeModal();
    }
  });

  // After successful Shopify contact submit, reopen modal on success state.
  if (modal.querySelector('[data-glt-vip-success]')) {
    openModal();
    if (window.history && window.history.replaceState) {
      var clean = window.location.pathname + window.location.hash;
      window.history.replaceState(null, '', clean);
    }
    track('vip_submit_success', '');
  } else if (modal.querySelector('.grail-linktree-vip__error')) {
    openModal();
  }
})();
